export default {
    stats: []
}
